import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { BULK_UPLOAD_AUDIT, GET_AUDIT_LIST, REGION_WISE_AUDIT_FILTER } from "../../constants";
import { Alert, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, LinearProgress, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from "@mui/material";
import moment from "moment";
import Loader from "../reusable Component/Loader";
import RuleBasedFilterPanel from "./RuleBasedFilterPanel";
import FileUploadIcon from '@mui/icons-material/FileUpload';

function MasterLeadListComponent({}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const [loading, setLoading] = useState(false);

 const [page, setPage] = useState(() => {
     // Retrieve persisted page from localStorage or default to 0
     const savedPage = localStorage.getItem("page");
     return savedPage !== null ? parseInt(savedPage, 10) : 0;
   });
 
   const [rowsPerPage, setRowsPerPage] = useState(() => {
     // Retrieve persisted rowsPerPage from localStorage or default to 10
     const savedRowsPerPage = localStorage.getItem("rowsPerPage");
     return savedRowsPerPage !== null ? parseInt(savedRowsPerPage, 10) : 20;
   });
  const [totalCount, setTotalCount] = useState(0);
  const [row, setRow] = useState([]);

  const [filters, setFilters] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  
 
  const fetchAuditLeadList = () => {
    setLoading(true);
    const filterQuery =
      filters && filters.length > 0 ? JSON.stringify(filters) : "[]";
    axios
      .get(
        `${REGION_WISE_AUDIT_FILTER}?page=${
          page + 1
        }&limit=${rowsPerPage}&filters=${filterQuery}&commonSearch=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      )
      .then((response) => {
        const { data, totalCount } = response.data;
        console.log(data);
        
        setRow(data);
        setTotalCount(totalCount);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        // setRow([]);
        console.error("Error fetching data", error);
      });
  };

  useEffect(()=>{
    fetchAuditLeadList();
  },[page, rowsPerPage,searchQuery, filters]);

  useEffect(() => {
      const persistedFilters = JSON.parse(localStorage.getItem("masterfilters")) || [];
      if (persistedFilters.length > 0) {
        setFilters(persistedFilters); // Update filters state with persisted data
      }
    }, []);

    // Save page and rowsPerPage to localStorage whenever they change
    useEffect(() => {
      localStorage.setItem("page", page);
      localStorage.setItem("rowsPerPage", rowsPerPage);
    }, [page, rowsPerPage]);

  // Define your column widths in a mapping
  const columnWidths = {
    SNo: "50px",
    "Last Action Date": "150px",
    "Zone Name": "150px",
    "Lot Number": "150px",
    "Farmer Name": "150px",
    "Branch Name": "150px",
    Vendor: "100px",
    "Shed Type": "100px",
    "Placed Quantity": "100px",
    CA: "100px",
    "Age (SAP)": "80px",
    Diff: "50px",
    "First Week Mortality": "120px",
    "First Week Mortality Percentage": "180px",
    "Mortality Quantity": "150px",
    "Mortality Percentage": "150px",
    "Lifting EA": "120px",
    "Lift Percentage": "120px",
    "Balance Birds": "120px",
    FCR: "150px",
    "Avg Body Weight": "120px",
    "BWT Age": "120px",
    "Feed Cons": "120px",
    "Lifted Avg Weight": "120px",
    "Prev Grade": "120px",
    "Mobile Number": "120px",
    "Hatch Date": "120px",
    Line: "120px",
    "Hatchery Name": "150px",
    "Last Modified On": "150px",
    "Follow-Up Date": "150px",
    Status: "120px",
    Action: "120px",
  };

  const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");
  
    const getColorForTag = (tag) => {
      switch (tag.toLowerCase()) {
        case "open":
          return "error";
        case "closed":
          return "success";
        default:
          return "default";
      }
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(page);
    };

    const [openSnackbar, setOpenSnackbar] = useState(false);
        const [severity, setSeverity] = useState('');
        const [alertTitle, setAlertTitle] = useState('');
        const [message, setMessage] = useState('');

    const [open, setOpen] = useState(false);
      const [uploading, setUploading] = useState(false);
      const [progress, setProgress] = useState(0);
      const [file, setFile] = useState(null);

      const fileInputRef = useRef();

      const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setOpen(true);
          setFile(file);
          // uploadFile(file);
      }
      
    };

    const handleUpload = () => {
      setUploading(true);
      setProgress(0);
      
      // Simulate file upload
      const uploadInterval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(uploadInterval);
            uploadFile(file);
            // setTimeout(() => setOpen(false), 1000);
            return 100;
          }
          return prevProgress + 10;
        });
      }, 500);
    };

    const uploadFile = (file) => {
      const formData = new FormData();
      formData.append('file', file);

      axios.post(BULK_UPLOAD_AUDIT, formData, {
          headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
      })
      .then(response => {
          console.log('File uploaded successfully:', response.data);
          setSeverity('success');
          setAlertTitle(response.data.message);
          setMessage('Updated Count:' + response.data.updatedCount);
          setOpenSnackbar(true);
          
          setUploading(false);
          setOpen(false);

          fileInputRef.current.value = null;
          
          // navigate(0);
          
      })
      .catch(error => {
          console.error('Error uploading file:', error);
          // setRunEffect(false);
          setSeverity('error');
          setMessage(error.response.data.message);
          setOpenSnackbar(true);
          
      });
    };
 
    const handleButtonClick = () => {
        fileInputRef.current.click();
      };

        const handleCloseDialog = () => {
            if (!uploading) {
            setOpen(false);
            setFile(null);
            }
        };
    
        const handleClose = (event, reason) => {
          if (reason === 'clickaway') {
            return;
          }
      
          setOpenSnackbar(false);
        };

  return (
    <>
      {loading && <Loader open={loading} />}

      

      <RuleBasedFilterPanel setFilters={setFilters} setPage={setPage} setRowsPerPage={setRowsPerPage}></RuleBasedFilterPanel>
      <Paper sx={{marginTop: 1}}>

        {/* File Input and Bulk Upload Button */}
        <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                />
                <Button
                    variant='outlined'
                    color='primary'
                    onClick={handleButtonClick}
                    className="mr-2"
                    sx={{ mr: 2 }} // Adds margin to the right
                >
                    <FileUploadIcon />
                    Bulk Upload
                </Button>
              {/* Search Bar */}
            <TextField
              label="Search"
              variant="outlined"
              sx={{float: "right", margin: 1}}
              size="small"
              margin="normal"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
        <TableContainer 
          sx={{
            boxShadow: 2,
            borderRadius: "8px",
            margin: "16px 0",
          }}
        >
          <Table
            sx={{ minWidth: 650, height: "100%", tableLayout: "fixed" }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
                <TableCell
                  align="center"
                  sx={{ width: columnWidths["SNo"] || "auto", padding: 0 }}
                >
                  SNo
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Last Action Date"] || "auto",
                    padding: 0,
                  }}
                >
                  Last Action Date
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Zone Name"] || "auto",
                    padding: 0,
                  }}
                >
                  Zone Name
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Lot Number"] || "auto",
                    padding: 0,
                  }}
                >
                  Lot Number
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Farmer Name"] || "auto",
                    padding: 0,
                  }}
                >
                  Farmer Name
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Branch Name"] || "auto",
                    padding: 0,
                  }}
                >
                  Branch Name
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ width: columnWidths["Vendor"] || "auto", padding: 0 }}
                >
                  Vendor
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Shed Type"] || "auto",
                    padding: 0,
                  }}
                >
                  Shed Type
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Placed Quantity"] || "auto",
                    padding: 0,
                  }}
                >
                  Placed Quantity
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ width: columnWidths["CA"] || "auto", padding: 0 }}
                >
                  CA
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Age (SAP)"] || "auto",
                    padding: 0,
                  }}
                >
                  Age (SAP)
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ width: columnWidths["Diff"] || "auto", padding: 0 }}
                >
                  Diff
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["First Week Mortality"] || "auto",
                    padding: 0,
                  }}
                >
                  First Week Mortality
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width:
                      columnWidths["First Week Mortality Percentage"] || "auto",
                    padding: 0,
                  }}
                >
                  First Week Mortality Percentage
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Mortality Quantity"] || "auto",
                    padding: 0,
                  }}
                >
                  Mortality Quantity
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Mortality Percentage"] || "auto",
                    padding: 0,
                  }}
                >
                  Mortality Percentage
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Lifting EA"] || "auto",
                    padding: 0,
                  }}
                >
                  Lifting EA
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Lift Percentage"] || "auto",
                    padding: 0,
                  }}
                >
                  Lift Percentage
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Balance Birds"] || "auto",
                    padding: 0,
                  }}
                >
                  Balance Birds
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ width: columnWidths["FCR"] || "auto", padding: 0 }}
                >
                  FCR
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Avg Body Weight"] || "auto",
                    padding: 0,
                  }}
                >
                  Avg Body Weight
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ width: columnWidths["BWT Age"] || "auto", padding: 0 }}
                >
                  BWT Age
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Feed Cons"] || "auto",
                    padding: 0,
                  }}
                >
                  Feed Cons
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Lifted Avg Weight"] || "auto",
                    padding: 0,
                  }}
                >
                  Lifted Avg Weight
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Prev Grade"] || "auto",
                    padding: 0,
                  }}
                >
                  Prev Grade
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Mobile Number"] || "auto",
                    padding: 0,
                  }}
                >
                  Mobile Number
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Hatch Date"] || "auto",
                    padding: 0,
                  }}
                >
                  Hatch Date
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ width: columnWidths["Line"] || "auto", padding: 0 }}
                >
                  Line
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Hatchery Name"] || "auto",
                    padding: 0,
                  }}
                >
                  Hatchery Name
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Follow-Up Date"] || "auto",
                    padding: 0,
                  }}
                >
                  Follow-Up Date
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Last Modified On"] || "auto",
                    padding: 0,
                  }}
                >
                  Last Modified On
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    width: columnWidths["Status"] || "auto",
                    padding: 0,
                    position: "sticky", // Make the cell sticky
                    right: 0, // Align it next to the Action column
                    backgroundColor: "#EEF0F4", // Set background color for visibility
                    zIndex: 10, // Higher z-index to stay above other cells
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  }}
                >
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(row) && row.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={34}>No Data Available Yet.</TableCell>
                </TableRow>
              ) : (
                
                row.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell
                      align="center"
                      sx={{ width: columnWidths["SNo"] || "auto", padding: 0 }}
                    >
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Last Action Date"] || "auto",
                        padding: 0,
                      }}
                    >
                      {(row.last_action_date === null || row.last_action_date === undefined) ? "-" : formatDate(row.last_action_date)}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Zone Name"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Zone_Name || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Lot Number"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Lot_Number || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Farmer Name"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Farmer_Name || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Branch Name"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Branch_Name || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Vendor"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Vendor || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Shed Type"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Shed_Type || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Placed Quantity"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Placed_Qty || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ width: columnWidths["CA"] || "auto", padding: 0 }}
                    >
                      {row.CA || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Age (SAP)"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Age_SAP || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ width: columnWidths["Diff"] || "auto", padding: 0 }}
                    >
                      {row.Diff || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["First Week Mortality"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.first_Week_M || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width:
                          columnWidths["First Week Mortality Percentage"] ||
                          "auto",
                        padding: 0,
                      }}
                    >
                      {(row.First_Week_Mortality_Percentage === null || row.First_Week_Mortality_Percentage === undefined || row.First_Week_Mortality_Percentage === "No Entry") ? "No Entry" : parseFloat(row.First_Week_Mortality_Percentage).toFixed(
                        3
                      )}
                      {/* {row.First_Week_Mortality_Percentage} */}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Mortality Quantity"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Total_Mortality || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Mortality Percentage"] || "auto",
                        padding: 0,
                      }}
                    >
                      {(row.Total_Mortality_Percentage === null || row.Total_Mortality_Percentage === undefined || row.Total_Mortality_Percentage === 'No Entry') ? 'No Entry' : parseFloat(row.Total_Mortality_Percentage).toFixed(3)}
                      {/* {row.Total_Mortality_Percentage} */}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Lifting EA"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Lifting_EA || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Lift Percentage"] || "auto",
                        padding: 0,
                      }}
                    >
                      {(row.Lift_Percentage=== null || row.Lift_Percentage === undefined || row.Lift_Percentage === "No Entry") ? "No Entry" : parseFloat(row.Lift_Percentage).toFixed(3)}
                      {/* {row.Lift_Percentage} */}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Balance Birds"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Bal_Birds || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ width: columnWidths["FCR"] || "auto", padding: 0 }}
                    >
                      {(row.FCR === null || row.FCR === undefined) ? "-" : parseFloat(row.FCR).toFixed(3)}
                      {/* {row.FCR} */}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Avg Body Weight"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.ABWT || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["BWT Age"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.BWT_Age || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Feed Cons"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Feed_Cons || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Lifted Avg Weight"] || "auto",
                        padding: 0,
                      }}
                    >
                      {(row.Avg_Lift_Wt === null || row.Avg_Lift_Wt === undefined) ? "-" : parseFloat(row.Avg_Lift_Wt).toFixed(3)}
                      {/* {row.Avg_Lift_Wt} */}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Prev Grade"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Prev_Grade || '-'}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Mobile Number"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Mobile || '-'}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Hatch Date"] || "auto",
                        padding: 0,
                      }}
                    >
                      {(row.Hatch_Date=== null || row.Hatch_Date === undefined) ? "-" : row.Hatch_Date}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ width: columnWidths["Line"] || "auto", padding: 0 }}
                    >
                      {row.Line || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Hatchery Name"] || "auto",
                        padding: 0,
                      }}
                    >
                      {row.Hatchery_Name || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Follow-Up Date"] || "auto",
                        padding: 0,
                      }}
                    >
                      {(row.follow_up_date === null || row.follow_up_date === undefined) ? "-" : formatDate(row.follow_up_date)}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Last Modified On"] || "auto",
                        padding: 0,
                      }}
                    >
                      {(row.updatedAt === null || row.updatedAt === undefined) ? "-" : formatDate(row.updatedAt)}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["Status"] || "auto",
                        padding: 0,
                        position: "sticky", // Make the cell sticky
                        right: 0, // Align it next to the Action column
                        backgroundColor: "#EEF0F4", // Set background color for visibility
                        zIndex: 10, // Higher z-index to stay above other cells
                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      }}
                    >
                      {row.status === "-" ? (
                        "-"
                      ) : (
                        <Chip
                          label={row.status}
                          color={`${getColorForTag(row.status)}`}
                          size="small"
                          sx={{ textTransform: "capitalize", margin: '5px' }}
                          
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20, 50]}
          component="div"
          count={totalCount} // Adjust this to reflect the total count of records, if available
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      <Dialog
        open={open}
        onClose={handleCloseDialog}
        fullWidth={true}
        maxWidth="sm"
      >
       <DialogTitle>{"Confirm Upload"}</DialogTitle>
        <DialogContent>
        <DialogContentText>
            {uploading ? "Uploading..." : "Are you sure you want to upload the selected file?"}
          </DialogContentText>
          {uploading && (
            <Box sx={{ width: '100%', mt: 2, height: '30px' }}>
              <LinearProgress variant="determinate" value={progress} />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
        {!uploading && (
            <>
              <Button onClick={handleCloseDialog} color="primary">
                Cancel
              </Button>
              <Button onClick={handleUpload} color="primary" autoFocus>
                Confirm
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
          <Alert
              onClose={handleClose}
              severity={severity}
              variant="filled"
              sx={{ width: '100%' }}
          >
              {/* <AlertTitle>{alertTitle}</AlertTitle> */}
              {alertTitle}
          </Alert>
          </Snackbar>
    </>
  );
}

export default MasterLeadListComponent;
